import { IMotoristaOptions, IOptions } from '../cadastro-agendamento.model';

export const EMPTY_OPTIONS = {
  default: (): IOptions[] => [{ name: '', value: '' }],
  motorista: (): IMotoristaOptions[] => [
    {
      name: '',
      value: '',
      cpf: '',
      cnh: '',
      telefone: ''
    }
  ],
  vinculo: (): IOptions[] => [
    { name: 'Ajudante', value: 1 },
    { name: 'Conferente', value: 2 },
    { name: 'Segurança', value: 3 },
    { name: 'Visitante', value: 4 },
    { name: 'Parente', value: 5 }
  ]
};
